export class UniqueIdGeneratorUtil {
	public static count = 0;

	public static getId () {
		UniqueIdGeneratorUtil.count++;

		return `unique-id-${UniqueIdGeneratorUtil.count}`;
	}
}
